export default __webpack_public_path__ + "static/media/ReggaeOne-Regular.42547fca.ttf";